import FacilityManagerContainer from "../../container/admin/facility-manager";

const FacilityManager = () => {
    return <FacilityManagerContainer />;
};

export default FacilityManager;